import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06905f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }

import { defineComponent, provide, ref, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import LayoutHeader from './header/index.vue'
import LayoutMain from './main/index.vue'
import MoocFooter from '@/components/footer/index.vue'
import LayoutFooter from './footer/index.vue'
import MoocHeader from '@/components/header/index.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { meta } = toRefs(useRoute())
const searchKeyword = ref('')

provide('searchKeyword', { searchKeyword })

defineComponent({
  components: {
    LayoutHeader,
    LayoutMain,
    LayoutFooter,
    MoocHeader,
    MoocFooter
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(LayoutHeader, { class: "layout-header" }, {
      default: _withCtx(() => [
        _createVNode(MoocHeader)
      ]),
      _: 1
    }, 512), [
      [_vShow, !_unref(meta).hideHeader]
    ]),
    _createVNode(LayoutMain, {
      class: "layout-main",
      style: _normalizeStyle({'margin-top': _unref(meta).hideHeader ? 0 : '72px'})
    }, null, 8, ["style"]),
    _withDirectives(_createVNode(LayoutFooter, { class: "layout-footer" }, {
      default: _withCtx(() => [
        _createVNode(MoocFooter)
      ]),
      _: 1
    }, 512), [
      [_vShow, !_unref(meta).hideFooter]
    ])
  ]))
}
}

})